import { Box, Column, Columns, Stack } from 'braid-design-system';
import type { FC } from 'react';

import * as styles from './JobApplicationCardLayout.css';

interface JobApplicationCardLayoutProps {
  avatarCheckBox: JSX.Element;
  fullNameAndCertifiedIcon: JSX.Element;
  recentRoleAndTenure: JSX.Element;
  keyInfo: JSX.Element | null;
  badges: JSX.Element;
  roleRequirementsDisclosure: JSX.Element | null;
  matchedSkillsDisclosure: JSX.Element | null;
  appliedDate: JSX.Element;
  attachmentsAndRecords: JSX.Element | null;
  actionButtons: JSX.Element;
}

export const JobApplicationCardLayout: FC<JobApplicationCardLayoutProps> = ({
  avatarCheckBox,
  fullNameAndCertifiedIcon,
  recentRoleAndTenure,
  keyInfo,
  badges,
  roleRequirementsDisclosure,
  matchedSkillsDisclosure,
  appliedDate,
  attachmentsAndRecords,
  actionButtons,
}) => (
  <Box
    background="surface"
    paddingX="small"
    paddingY="medium"
    position="relative"
    data={{ testid: 'job-application-card' }}
    className={styles.applicationCard}
  >
    <Columns space="xsmall">
      <Column hideBelow="tablet" width="content">
        {avatarCheckBox}
      </Column>
      <Column>
        {/* FIXME: NVL - change to using Stack with a space medium */}
        <Box style={{ gap: '24px' }} display="flex" flexDirection="column">
          {/* FIXME: NVL - change to small */}
          <Stack space="medium">
            {/* FIXME: NVL - change to ['small', 'xsmall'] */}
            <Stack space="small">
              {fullNameAndCertifiedIcon}
              {recentRoleAndTenure}
            </Stack>
            {keyInfo}
            {badges}
          </Stack>

          {roleRequirementsDisclosure}
          {matchedSkillsDisclosure}
          {appliedDate}

          <Box
            display={{
              mobile: 'none',
              tablet: 'none',
              desktop: 'none',
              wide: 'block',
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="spaceBetween"
            >
              {attachmentsAndRecords}
              {actionButtons}
            </Box>
          </Box>

          <Box
            display={{
              mobile: 'block',
              tablet: 'block',
              desktop: 'block',
              wide: 'none',
            }}
          >
            <Box className={styles.grid}>
              <Box className={styles.gridRow}>{attachmentsAndRecords}</Box>
              <Box className={styles.gridRow}>{actionButtons}</Box>
            </Box>
          </Box>
        </Box>
      </Column>
    </Columns>
  </Box>
);
